// extracted by mini-css-extract-plugin
module.exports = {"menu":"_103a151b99--menu--rh0sT","item":"_103a151b99--item--OjI8s"};